module.exports = __webpack_public_path__ + "static/media/Victoria_H@3x.6b121a86.jpg";